import http from './httpClient'
import { bffURL } from '../config'
import Jwt from '../services/jwt'
import { transformQueryString } from '../util/util'

export default class UploadAnswers {
  static async post (answerJson, isInternalApplicant = null, isUUIDRoute = false) {
    const idToken = Jwt.getIdToken()

    let queryString = transformQueryString(window.location.search, isUUIDRoute)
    if (isInternalApplicant === true || isInternalApplicant === false) {
      const separator = queryString ? '&' : '?'
      queryString = `${queryString}${separator}isInternalApplicant=${isInternalApplicant}`
    }

    if (idToken) {
      try {
        return await http.post(`${bffURL}/auth/applications${queryString}`, answerJson, idToken)
      } catch (e) {
        if (e?.response?.status === 401) {
          return await http.post(`${bffURL}/applications${queryString}`, answerJson).catch(e => (console.warn(`Failed to fetch: ${e}`)))
        } else {
          console.warn(`Failed to post auth application: ${e}`)
        }
      }
    } else {
      return await http.post(`${bffURL}/applications${queryString}`, answerJson).catch(e => (console.warn(`Failed to post anonymous application: ${e}`)))
    }
  }
}
